// Licensed to Elasticsearch B.V under one or more agreements.
// Elasticsearch B.V licenses this file to you under the Apache 2.0 License.
// See the LICENSE file in the project root for more information
'use strict';

var _createClass = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _classCallCheck = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var ElasticsearchClientError = /*#__PURE__*/function (_Error) {
  _inherits(ElasticsearchClientError, _Error);

  function ElasticsearchClientError(message) {
    var _this;

    _classCallCheck(this, ElasticsearchClientError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ElasticsearchClientError).call(this, message));
    _this.name = 'ElasticsearchClientError';
    return _this;
  }

  return ElasticsearchClientError;
}(_wrapNativeSuper(Error));

var TimeoutError = /*#__PURE__*/function (_ElasticsearchClientE) {
  _inherits(TimeoutError, _ElasticsearchClientE);

  function TimeoutError(message, meta) {
    var _this2;

    _classCallCheck(this, TimeoutError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TimeoutError).call(this, message));
    Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this2)), TimeoutError);
    _this2.name = 'TimeoutError';
    _this2.message = message || 'Timeout Error';
    _this2.meta = meta;
    return _this2;
  }

  return TimeoutError;
}(ElasticsearchClientError);

var ConnectionError = /*#__PURE__*/function (_ElasticsearchClientE2) {
  _inherits(ConnectionError, _ElasticsearchClientE2);

  function ConnectionError(message, meta) {
    var _this3;

    _classCallCheck(this, ConnectionError);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionError).call(this, message));
    Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this3)), ConnectionError);
    _this3.name = 'ConnectionError';
    _this3.message = message || 'Connection Error';
    _this3.meta = meta;
    return _this3;
  }

  return ConnectionError;
}(ElasticsearchClientError);

var NoLivingConnectionsError = /*#__PURE__*/function (_ElasticsearchClientE3) {
  _inherits(NoLivingConnectionsError, _ElasticsearchClientE3);

  function NoLivingConnectionsError(message, meta) {
    var _this4;

    _classCallCheck(this, NoLivingConnectionsError);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(NoLivingConnectionsError).call(this, message));
    Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this4)), NoLivingConnectionsError);
    _this4.name = 'NoLivingConnectionsError';
    _this4.message = message || 'No Living Connections Error';
    _this4.meta = meta;
    return _this4;
  }

  return NoLivingConnectionsError;
}(ElasticsearchClientError);

var SerializationError = /*#__PURE__*/function (_ElasticsearchClientE4) {
  _inherits(SerializationError, _ElasticsearchClientE4);

  function SerializationError(message) {
    var _this5;

    _classCallCheck(this, SerializationError);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(SerializationError).call(this, message));
    Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this5)), SerializationError);
    _this5.name = 'SerializationError';
    _this5.message = message || 'Serialization Error';
    return _this5;
  }

  return SerializationError;
}(ElasticsearchClientError);

var DeserializationError = /*#__PURE__*/function (_ElasticsearchClientE5) {
  _inherits(DeserializationError, _ElasticsearchClientE5);

  function DeserializationError(message) {
    var _this6;

    _classCallCheck(this, DeserializationError);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(DeserializationError).call(this, message));
    Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this6)), DeserializationError);
    _this6.name = 'DeserializationError';
    _this6.message = message || 'Deserialization Error';
    return _this6;
  }

  return DeserializationError;
}(ElasticsearchClientError);

var ConfigurationError = /*#__PURE__*/function (_ElasticsearchClientE6) {
  _inherits(ConfigurationError, _ElasticsearchClientE6);

  function ConfigurationError(message) {
    var _this7;

    _classCallCheck(this, ConfigurationError);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(ConfigurationError).call(this, message));
    Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this7)), ConfigurationError);
    _this7.name = 'ConfigurationError';
    _this7.message = message || 'Configuration Error';
    return _this7;
  }

  return ConfigurationError;
}(ElasticsearchClientError);

var ResponseError = /*#__PURE__*/function (_ElasticsearchClientE7) {
  _inherits(ResponseError, _ElasticsearchClientE7);

  function ResponseError(meta) {
    var _this8;

    _classCallCheck(this, ResponseError);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(ResponseError).call(this, 'Response Error'));
    Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this8)), ResponseError);
    _this8.name = 'ResponseError';
    _this8.message = meta.body && meta.body.error && meta.body.error.type || 'Response Error';
    _this8.meta = meta;
    return _this8;
  }

  _createClass(ResponseError, [{
    key: "body",
    get: function get() {
      return this.meta.body;
    }
  }, {
    key: "statusCode",
    get: function get() {
      if (this.meta.body && typeof this.meta.body.status === 'number') {
        return this.meta.body.status;
      }

      return this.meta.statusCode;
    }
  }, {
    key: "headers",
    get: function get() {
      return this.meta.headers;
    }
  }]);

  return ResponseError;
}(ElasticsearchClientError);

module.exports = {
  ElasticsearchClientError: ElasticsearchClientError,
  TimeoutError: TimeoutError,
  ConnectionError: ConnectionError,
  NoLivingConnectionsError: NoLivingConnectionsError,
  SerializationError: SerializationError,
  DeserializationError: DeserializationError,
  ConfigurationError: ConfigurationError,
  ResponseError: ResponseError
};